import { render } from "./BaseButton.vue?vue&type=template&id=1de85249&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=1de85249&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de85249"]])

export default __exports__